import Vue from 'vue';
import { initGrowthbook } from '@/lib/growthbook';
import { installGoogleMapsVuePlugin } from '@/lib/installGoogleMapsVuePlugin';
import { setupBraze } from '../lib/braze';
import { initSiftAccount, injectSiftScript, shouldTrackSift } from '@/lib/sift';

declare global {
  interface Window {
    dataLayer: any[];
    analytics: any;
    google: any;
  }
}

window.dataLayer = window.dataLayer || [];

const Sittercity = Vue.extend({});

document.addEventListener('DOMContentLoaded', async () => {
  try {
    await installGoogleMapsVuePlugin();
  } catch (error) {
    console.warn('Google Maps Vue plugin setup failed:', error);
  }

  try {
    if (shouldTrackSift()) {
      injectSiftScript();
      initSiftAccount();
    }
  } catch (error) {
    console.warn('Sift setup failed:', error);
  }

  try {
    setupBraze();
  } catch (error) {
    console.warn('Braze setup failed:', error);
  }

  try {
    await initGrowthbook();
  } catch (error) {
    console.warn('GrowthBook setup failed:', error);
  }
});

export default Sittercity;
